import React, { PureComponent } from 'react';
import Grid from '@material-ui/core/Grid';
import { propTypes } from './../../shapes/ClinicDetailPage';
import styled from 'styled-components';
import Sections from './Sections';
import { ROOT_PADDING } from './constants';
import NearbyClinics from './Book/components/NearbyClinics';
import SchemaOrgMainAttributes from './MetaTags/SchemaOrgMainAttributes';
import NearbyTelemed from './Book/components/NearbyTelemed';
import { isBookable, isTraditionalLocation } from '../../core/util/location';
import { colors } from '../../constants/colors';
import MobileCdpHeaderCard from './HeaderCard/MobileCdpHeaderCard';

/* This is crucial for the sticky mobile book button.
 * If you change the HTML of the root, make sure that the
 * cdp doesn't suddenly have a horizontal scroll bar on mobile.
 * Changing the constant value is fine */
const Root = styled(Grid)`
  background-color: ${colors.theWhiteAlbum};
  width: 100vw;
  overflow: hidden;
  padding: 0 ${ROOT_PADDING}px;
`;

export default class Mobile extends PureComponent {
  static propTypes = propTypes;

  render = () => {
    const {
      location,
      handleOpenCarousel,
      viewport,
      showModal,
      nearbyLocations,
      className,
      sessionTrackingProperties,
    } = this.props;

    return (
      <Root container className={className} itemScope itemType="http://schema.org/MedicalClinic">
        <SchemaOrgMainAttributes location={location} />
        <Grid item xs={12}>
          <MobileCdpHeaderCard
            location={location}
            handleOpenCarousel={handleOpenCarousel}
            showModal={showModal}
            sessionTrackingProperties={sessionTrackingProperties}
          />
          <Sections
            location={location}
            enableCollapsing
            defaultExpanded
            handleOpenCarousel={() => handleOpenCarousel('photosSection')}
            viewport={viewport}
            showModal={showModal}
            sessionTrackingProperties={sessionTrackingProperties}
          />
          <NearbyTelemed location={nearbyLocations.telemed} referrerId={location.id} />
          {!isBookable(location) && !isTraditionalLocation(location) && (
            <NearbyClinics currentLocation={location} nearbyClinics={nearbyLocations.nearby} />
          )}
        </Grid>
      </Root>
    );
  };
}
